module.exports = "#spaced-button-1{\n  margin: 1em;\n}\n\n#spaced-button-2{\n  margin: 1em;\n}\n"